export default "__VITE_ASSET__BqGWGAX6__"